"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Location = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 10,
  height: 12,
  viewBox: "0 0 10 12"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M8.54 1.487a4.953 4.953 0 00-7.075 0 5.128 5.128 0 000 7.178l3.108 3.158a.585.585 0 00.837 0l3.13-3.188a5.107 5.107 0 000-7.148zM6.426 6.403A2 2 0 117 5.004a2 2 0 01-.618 1.4h.043z",
  fill: "#ACB3BE",
  fillRule: "nonzero"
}));

var _default = Location;
exports.default = _default;